// Live preview for the dealership settings form: how the loaded inventory
// would fall into the aging buckets and the asking-vs-AI states under the
// values being edited (computed client-side, nothing is saved).
import { aiPriceGap } from './aiPrice';
import { gapDirection } from './lotValue';
import { agingBucketIdForDays, buildAgingBuckets, SETTING_KEYS } from './dealershipSettings';

const isUsed = (u) => {
    const s = String(u?.NewUsedStatus ?? u?.TYPE ?? '').trim().toUpperCase();
    return s === 'U' || s === 'USED';
};

/**
 * { aging: [{ id, label, count }] | null, gap: { inline, above, wellAbove,
 * below, priced } | null, total } for typed values. A group whose values do
 * not validate is null (nothing sensible to show).
 */
export const settingsPreview = (units, values, { agingValid = true, gapValid = true } = {}) => {
    const list = Array.isArray(units) ? units : [];
    let aging = null;
    if (agingValid) {
        const boundaries = values[SETTING_KEYS.agingBoundaries];
        const counts = { 1: 0, 2: 0, 3: 0, 4: 0 };
        list.forEach((u) => {
            const id = agingBucketIdForDays(u?.DaysInStock, boundaries);
            if (id) counts[id] += 1;
        });
        aging = buildAgingBuckets(boundaries).map((b) => ({ id: b.id, label: b.label, tone: b.tone, count: counts[b.id] }));
    }
    let gap = null;
    if (gapValid) {
        const t = {
            neutral: values[SETTING_KEYS.gapNeutral] / 100,
            warn: values[SETTING_KEYS.gapWarn] / 100,
            critical: values[SETTING_KEYS.gapCritical] / 100,
        };
        gap = { inline: 0, above: 0, wellAbove: 0, below: 0, priced: 0 };
        list.filter(isUsed).forEach((u) => {
            if (u.PriceStatus === 'Review') return;
            const g = aiPriceGap(u);
            if (g === null) return;
            const state = gapDirection(g, t);
            if (state && state in gap) {
                gap[state] += 1;
                gap.priced += 1;
            }
        });
    }
    return { aging, gap, total: list.length };
};
